import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { FunctionComponent, useEffect, useState } from 'react';
import ClientDetailTable from './ClientDetailTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { getClientReport } from 'actions/insights/clientsAndPets/clientList/ClientReportActions';
import { useApiClientWrapper, useMarketplace } from 'hooks';
import { ClientReport, ClientsReport } from 'model/ClientAndPetsReport';
import { Pagination, Period } from '@spike/model';
import moment from 'moment-timezone';
import { ClientReportStatus, ClientReportState } from 'reducers/clientReport/ClientReportState';
import Header from '../../components/Header';

interface ClientListProps {
    description?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            backgroundColor: 'white',
            height: 'fit-content',

            [theme.breakpoints.up('md')]: {
                //padding: '50px 24px'
            }
        },
        mobileWrapper: {
            [theme.breakpoints.down('sm')]: {
                marginTop: 24
            }
        }
    })
);

export const ClientList: FunctionComponent<ClientListProps> = props => {
    const classes = useStyles();

    const dispatch = useDispatch();

    const clientLoading = useSelector<RootState, boolean>(state => state.clientReport.loading);

    const clientStatus = useSelector<RootState, ClientReportStatus>(state => state.clientReport.status);

    const clientReport = useSelector<RootState, ClientReportState>(state => state.clientReport);

    const [period, setPeriod] = useState<Period | null>(null);

    const [clientsReportConverted, setClientsReportConverted] = useState<Array<ClientReport> | null>(null);

    const [page, setPage] = useState(1);

    const [pageSize, setPageSize] = useState(10);

    const [pagination, setPagination] = useState<Pagination>({
        page: Number(clientReport.page),
        pageSize: Number(clientReport.size),
        totalPages: Number(clientReport.totalPages),
        totalRecords: Number(clientReport.totalRecords)
    });

    const apiClientWrapper = useApiClientWrapper();
    const marketplace = useMarketplace();

    const exportFile = {
        name: `Client Information ${marketplace.basics.businessName}.csv`,
        url: `/export_data?marketplace_id=${apiClientWrapper.marketplaceId}`,
        apiClientWrapper: apiClientWrapper
    };

    const calendar = {
        optionSelected: 'All time'
    };

    useEffect(() => {
        dispatch(getClientReport(page, pageSize, period?.from.format('YYYY/MM/DD'), period?.to.format('YYYY/MM/DD')));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [period, page, pageSize]);

    useEffect(() => {
        if (clientStatus === ClientReportStatus.GettingSuccess) {
            setClientsReportConverted(clientReport.pets);
            setPagination({
                page: Number(clientReport.page),
                pageSize: Number(clientReport.size),
                totalPages: Number(clientReport.totalPages),
                totalRecords: Number(clientReport.totalRecords)
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientStatus]);

    const handleChangePeriod = (dateFilter: Period | null, allTime: boolean) => {
        if (allTime) {
            setPeriod(null);
        } else {
            setPeriod({
                from: dateFilter?.from || moment(),
                to: dateFilter?.to || moment()
            });
        }
    };

    const changePageHandler = (page: number) => {
        setPage(page);
    };

    const changePageSizeHandler = (pageSize: number) => {
        setPageSize(pageSize);
        setPage(1);
    };

    return (
        <Box className={classes.container}>
            <Box>
                <Typography color="textSecondary"> {props.description} </Typography>
            </Box>
            <Box className={classes.mobileWrapper}>
                <Header
                    period={period}
                    onChangePeriod={handleChangePeriod}
                    exportFile={exportFile}
                    calendar={calendar}
                    hideAllTime={true}
                />
            </Box>
            <ClientDetailTable
                loading={clientLoading}
                clients={clientsReportConverted}
                pagination={pagination}
                changePageHandler={changePageHandler}
                changePageSizeHandler={changePageSizeHandler}
            />
        </Box>
    );
};

export default ClientList;
